import { FC } from "react";
import { solutions } from "../Solutions/Solutions.json";
import { HomeSolution } from "./HomeSolution";
import "./Home.scss";

export const Home: FC = () => {
  return (
    <div className="Home">
      <div className="Splash">
        <div className="Splash_headline">
          <div className="Splash_box">
            <div className="Splash_box__subheader">
              <span>Integrity.</span>
              <span>Innovation.</span>
              <span>Ingenuity.</span>
            </div>
          </div>
        </div>
        <div className="Home_Solutions-content-wrapper">
          <div className="Home_Solutions-solution-content">
            {solutions.map((solution) => (
              <HomeSolution solution={solution.header} icon={solution.icon} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
